<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <!-- 年 -->
                    <el-date-picker v-model="formDatas.slsYear" type="year" value-format="yyyy" @change="partserch"
                        placeholder="选择年" size="mini" style="width: 150px">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.slsMonth" type="month" value-format="yyyyMM" @change="partserch"
                        placeholder="选择月" size="mini" style="width: 150px; margin-left: 10px">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.slsDate" type="date" value-format="yyyyMMdd" @change="partserch"
                        placeholder="选择日" size="mini" style="width: 150px; margin-left: 10px">
                    </el-date-picker>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>
                    <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量撤销</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen(1)"
                        v-if="!dialog">柱状图</el-button>
                    <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen(2)"
                        v-if="dialog">表格</el-button>

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div style="height: 100%;" v-if="dialog">
                <div ref="eCharts1" style="width: 100%;height: 100%;" v-if="dialog"></div>
            </div>
            <div class="tablecss" v-if="dialog == false"
                v-loading="tableLoading"
                element-loading-background="rgba(255, 255, 255, 0.9)"
                element-loading-text="数据加载中..."
                element-loading-spinner="el-icon-loading"
                custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="slsId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>


        </div>
        <el-dialog title="活跃用户时间段分布" :visible.sync="diaDetail" width="80%" :close-on-click-modal="false"
            :before-close="handleClose">
            <div ref="eCharts2" style="width: 100%;height: 500px;"></div>
        </el-dialog>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { deleteSysRegion, getSysLogStatisticsList, getSysLogStatisticsDetails, updateSysRegion } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        let self = this;
        return {
            gradientColors: [
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#a8c8ff' },  // 淡蓝
                        { offset: 1, color: '#73a6ff' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#a8f0d0' },  // 淡绿
                        { offset: 1, color: '#73d1a4' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#d1c4e9' },  // 淡紫
                        { offset: 1, color: '#b39ddb' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#fff59d' },  // 淡黄
                        { offset: 1, color: '#fff176' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#ffccd5' },  // 淡粉
                        { offset: 1, color: '#ff9aa2' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#c8e6c9' },  // 淡青
                        { offset: 1, color: '#a5d6a7' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#b3e5fc' },  // 淡天蓝
                        { offset: 1, color: '#81d4fa' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#c8e6c9' },  // 淡薄荷绿
                        { offset: 1, color: '#a5d6a7' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#e1bee7' },  // 淡丁香紫
                        { offset: 1, color: '#ce93d8' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#fff9c4' },  // 淡香槟黄
                        { offset: 1, color: '#fff59d' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#f8bbd0' },  // 淡蔷薇粉
                        { offset: 1, color: '#f48fb1' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#dcedc8' },  // 淡青柠绿
                        { offset: 1, color: '#c5e1a5' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#bbdefb' },  // 淡婴儿蓝
                        { offset: 1, color: '#90caf9' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#a7ffeb' },  // 淡绿松石
                        { offset: 1, color: '#64ffda' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#d1c4e9' },  // 淡薰衣草紫
                        { offset: 1, color: '#b39ddb' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#fff8e1' },  // 淡象牙黄
                        { offset: 1, color: '#ffecb3' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#f3e5f5' },  // 淡薰衣草粉
                        { offset: 1, color: '#e1bee7' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#e0f7fa' },  // 淡天青蓝
                        { offset: 1, color: '#b2ebf2' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#f1f8e9' },  // 淡橄榄绿
                        { offset: 1, color: '#dcedc8' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#ede7f6' },  // 淡鸢尾紫
                        { offset: 1, color: '#d1c4e9' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#fff3e0' },  // 淡珊瑚橙
                        { offset: 1, color: '#ffe0b2' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#e8f5e9' },  // 淡苹果绿
                        { offset: 1, color: '#c8e6c9' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#e0f2f1' },  // 淡薄荷蓝
                        { offset: 1, color: '#b2dfdb' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#f3e5f5' },  // 淡紫罗兰
                        { offset: 1, color: '#e1bee7' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#fff8e1' },  // 淡奶油黄
                        { offset: 1, color: '#ffecb3' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#fbe9e7' },  // 淡橙粉
                        { offset: 1, color: '#ffccbc' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#e3f2fd' },  // 淡冰蓝
                        { offset: 1, color: '#bbdefb' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#f1f8e9' },  // 淡苔藓绿
                        { offset: 1, color: '#dcedc8' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#ede7f6' },  // 淡丁香
                        { offset: 1, color: '#d1c4e9' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#a8c8ff' },  // 淡蓝
                        { offset: 1, color: '#73a6ff' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#a8f0d0' },  // 淡绿
                        { offset: 1, color: '#73d1a4' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#d1c4e9' },  // 淡紫
                        { offset: 1, color: '#b39ddb' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#fff59d' },  // 淡黄
                        { offset: 1, color: '#fff176' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#ffccd5' },  // 淡粉
                        { offset: 1, color: '#ff9aa2' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#c8e6c9' },  // 淡青
                        { offset: 1, color: '#a5d6a7' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#b3e5fc' },  // 淡天蓝
                        { offset: 1, color: '#81d4fa' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#c8e6c9' },  // 淡薄荷绿
                        { offset: 1, color: '#a5d6a7' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#e1bee7' },  // 淡丁香紫
                        { offset: 1, color: '#ce93d8' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#fff9c4' },  // 淡香槟黄
                        { offset: 1, color: '#fff59d' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#f8bbd0' },  // 淡蔷薇粉
                        { offset: 1, color: '#f48fb1' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#dcedc8' },  // 淡青柠绿
                        { offset: 1, color: '#c5e1a5' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#bbdefb' },  // 淡婴儿蓝
                        { offset: 1, color: '#90caf9' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#a7ffeb' },  // 淡绿松石
                        { offset: 1, color: '#64ffda' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#d1c4e9' },  // 淡薰衣草紫
                        { offset: 1, color: '#b39ddb' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#fff8e1' },  // 淡象牙黄
                        { offset: 1, color: '#ffecb3' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#f3e5f5' },  // 淡薰衣草粉
                        { offset: 1, color: '#e1bee7' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#e0f7fa' },  // 淡天青蓝
                        { offset: 1, color: '#b2ebf2' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#f1f8e9' },  // 淡橄榄绿
                        { offset: 1, color: '#dcedc8' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#ede7f6' },  // 淡鸢尾紫
                        { offset: 1, color: '#d1c4e9' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#fff3e0' },  // 淡珊瑚橙
                        { offset: 1, color: '#ffe0b2' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#e8f5e9' },  // 淡苹果绿
                        { offset: 1, color: '#c8e6c9' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#e0f2f1' },  // 淡薄荷蓝
                        { offset: 1, color: '#b2dfdb' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#f3e5f5' },  // 淡紫罗兰
                        { offset: 1, color: '#e1bee7' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#fff8e1' },  // 淡奶油黄
                        { offset: 1, color: '#ffecb3' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#fbe9e7' },  // 淡橙粉
                        { offset: 1, color: '#ffccbc' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#e3f2fd' },  // 淡冰蓝
                        { offset: 1, color: '#bbdefb' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#f1f8e9' },  // 淡苔藓绿
                        { offset: 1, color: '#dcedc8' }
                    ]
                },
                {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#ede7f6' },  // 淡丁香
                        { offset: 1, color: '#d1c4e9' }
                    ]
                }
            ],
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'slsId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "slsYear",
                    key: "slsYear",
                    title: "年份",
                    align: "center",
                    fixed: 'left',
                    width: 120,
                },
                {
                    field: "slsDate",
                    key: "slsDate",
                    title: "日期",
                    align: "center",
                    fixed: 'left',
                    width: 120,
                },

                {
                    field: "slsUserNum",
                    key: "slsUserNum",
                    title: "活跃用户数量",
                    align: "center",
                    width: 120,
                },
                {
                    field: "slsLogNum",
                    key: "slsLogNum",
                    title: "日志数量",
                    align: "center",
                    width: 120,
                },
                {
                    field: "slsStatus",
                    key: "slsStatus",
                    title: "状态",
                    align: "center",
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.slsStatus == 1 ? <el-tag size="mini" type="danger">待处理</el-tag> : '已处理';
                    },
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 90,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: green"
                                    on-click={() => this.handleDetail(row)}
                                >
                                    时间段
                                </el-button>

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                srSuperiorCode: '',
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},

            echartsStr: "",
            echartsStrValue: {
                dataX: [],
                dataY: [],
                dataZ: []
            },
            echartsStr2: "",
            echartsStrValue2: {
                dataX: [],
                dataY: [],
                dataZ: []
            },
            color: [
                " #4992ff",
                " #dd79ff",
                " #fddd60",
                "  #ff6e76",
                " #58d9f9",
                " #05c091",
                "  #ff8a45",
                " #8d48e3"
            ],
            tableLoading: false,
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() {
        var that = this
        window.addEventListener("resize", function () {
            that.$nextTick(() => {
                that.echartsStr.resize();
                that.echartsStr2.resize();
            });
        });
    },
    methods: {
        handleDetail(row) {
            getSysLogStatisticsDetails({ slsId: row.slsId }).then(res => {
                this.tableDataDetail = res.data;
                this.diaDetail = true;
                this.getEChartValueTable2()
                this.$nextTick(() => {
                    this.DrawEcharts2();
                })
            })
        },
        handleClose() {
            this.diaDetail = false;
            this.tableDataDetail = []
            this.echartsStr2.dispose();
            this.echartsStr2 = null;

        },
        handleChange(value) {
            console.log(value);
            let nodesInfo = this.$refs['cascader'].getCheckedNodes()
            this.form.asCity = nodesInfo[0].pathLabels.join(' ');
            this.form.srSuperiorCode = value[value.length - 1];
            console.log(this.form.asCity, nodesInfo)
        },
        expandChange(e) {
            console.log(e);

        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },



        DrawEcharts() {
            var that = this;
            console.log(that.$refs.eCharts1);
            that.echartsStr = that.$echarts.init(that.$refs.eCharts1);
            that.echartsStr.setOption({
                title: {
                    text: '',
                    left: 'center'
                },
                legend: {
                    top: '10px', // 图例位置（顶部，可调整为left/right/bottom）
                    left: 'center', // 水平居中
                    textStyle: { fontSize: 12 }, // 图例文字样式
                    selectedMode: 'multiple', // 选中模式：multiple（允许多选，默认）/ single（单选）/ false（禁用交互）
                    data: ['人数', '日志数量'] // 必须与series中的name完全一致！
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    backgroundColor: 'rgba(255,255,255,0.9)',
                    textStyle: { color: '#333' },
                    formatter: function (params) {
                        return `<div style="font-weight:bold;">${params[0].name}</div>
                  <div>人数: <span style="color:${params[0].color}">${params[0].value}人</span></div>
                   <div>日志数量: <span >${params[1] ? params[1].value : '0'}人</span></div>`;
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '1%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: that.echartsStrValue.dataX,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        color: '#666',
                        fontSize: 15,
                        fontWeight: 'bold',
                        // rotate: 45,
                        interval: 0,
                        rotate: 90,   // 旋转90度实现竖向排列
                        align: 'center',
                        verticalAlign: 'middle',
                        top: 130,
                        margin: 50,
                    }
                },
                yAxis: [{
                    type: 'value',
                    name: '人数 ',
                    min: 0,
                    interval: 50,
                    axisLabel: {
                        color: '#666',
                        fontWeight: 'bold',
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#eee'
                        }
                    }
                }, {
                    type: 'value',
                    name: '日志数量',
                    min: 0,
                    axisLabel: {
                        color: '#666'
                    },
                    splitLine: {
                        show: false
                    }
                }],
                series: [
                    {
                        name: '人数',
                        type: 'bar',
                        barWidth: '20%',
                        data: that.echartsStrValue.dataY,
                        label: {
                            show: true,
                            position: 'top',
                            formatter: '{c}人',
                            color: '#333',
                            fontWeight: 'bold'
                        },
                        itemStyle: {
                            borderRadius: [8, 8, 0, 0],
                            // 为每个柱子应用不同的渐变色
                            color: function (params) {
                                return that.gradientColors[params.dataIndex];
                            }
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.3)'
                            }
                        }
                    },

                    {
                        name: '日志数量',
                        type: 'line',
                        yAxisIndex: 1,
                        data: that.echartsStrValue.dataZ,
                        lineStyle: {
                            width: 3,
                            color: function (params) {
                                return that.gradientColors[params.dataIndex];
                            },
                            fontWeight: 'bold'
                        },
                        itemStyle: {
                            color: function (params) {
                                return that.gradientColors[params.dataIndex];
                            },
                            borderWidth: 2,
                            fontWeight: 'bold'
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color: 'red',
                            distance: 10,
                            fontWeight: 'bold'
                        },
                        symbol: 'circle',
                        symbolSize: 8,

                    }
                ]
            });
        },
        getEChartValueTable() {
            this.echartsStrValue = {
                dataX: [],
                dataY: [],
                dataZ: []
            }
            this.tableData.forEach(item => {
                this.echartsStrValue.dataX.push(item.slsDate)
                this.echartsStrValue.dataY.push(item.slsUserNum)
                this.echartsStrValue.dataZ.push(item.slsLogNum)
            })
        },
        DrawEcharts2() {
            var that = this;
            console.log(that.$refs.eCharts1);
            that.echartsStr2 = that.$echarts.init(that.$refs.eCharts2);
            that.echartsStr2.setOption({
                title: {
                    text: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    backgroundColor: 'rgba(255,255,255,0.9)',
                    textStyle: { color: '#333' },
                    formatter: function (params) {
                        return `<div style="font-weight:bold;">${params[0].name}</div>
                  <div>人数: <span style="color:${params[0].color}">${params[0].value}人</span></div>
                    <div>日志数量: <span >${params[1] ? params[1].value : '0'}人</span></div>`;
                    }
                },
                legend: {
                    top: '10px', // 图例位置（顶部，可调整为left/right/bottom）
                    left: 'center', // 水平居中
                    textStyle: { fontSize: 12 }, // 图例文字样式
                    selectedMode: 'multiple', // 选中模式：multiple（允许多选，默认）/ single（单选）/ false（禁用交互）
                    data: ['人数', '日志数量'] // 必须与series中的name完全一致！
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: that.echartsStrValue2.dataX,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        color: '#666',
                        fontSize: 15,
                        fontWeight: 'bold',
                        // rotate: 45,
                        interval: 0,  // 强制显示所有标签，不会自动隐藏

                    }
                },

                yAxis: [{
                    type: 'value',
                    name: '人数 ',
                    min: 0,
                    interval: 50,
                    axisLabel: {
                        color: '#666',
                        fontWeight: 'bold',
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#eee'
                        }
                    }
                }, {
                    type: 'value',
                    name: '日志数量',
                    min: 0,
                    axisLabel: {
                        color: '#666'
                    },
                    splitLine: {
                        show: false
                    }
                }],
                series: [
                    {
                        name: '人数',
                        type: 'bar',
                        barWidth: '40%',
                        data: that.echartsStrValue2.dataY,
                        label: {
                            show: true,
                            position: 'top',
                            formatter: '{c}人',
                            color: '#333',
                            fontWeight: 'bold'
                        },
                        itemStyle: {
                            borderRadius: [8, 8, 0, 0],
                            // 为每个柱子应用不同的渐变色
                            color: function (params) {
                                return that.gradientColors[params.dataIndex];
                            }
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.3)'
                            }
                        }
                    },
                    {
                        name: '日志数量',
                        type: 'line',
                        yAxisIndex: 1,
                        data: that.echartsStrValue2.dataZ,
                        lineStyle: {
                            width: 3,
                            color: function (params) {
                                return that.gradientColors[params.dataIndex];
                            },
                            fontWeight: 'bold'
                        },
                        itemStyle: {
                            color: function (params) {
                                return that.gradientColors[params.dataIndex];
                            },
                            borderWidth: 2,
                            fontWeight: 'bold'
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color: 'red',
                            distance: 10,
                            fontWeight: 'bold'
                        },
                        symbol: 'circle',
                        symbolSize: 8,

                    }
                ]
            });
        },
        getEChartValueTable2() {
            this.echartsStrValue2 = {
                dataX: [],
                dataY: [],
                dataZ: []
            }
            this.tableDataDetail.forEach(item => {
                this.echartsStrValue2.dataX.push(item.slsTime + ':00')
                this.echartsStrValue2.dataY.push(item.slsUserNum)
                this.echartsStrValue2.dataZ.push(item.slsLogNum)
            })
        },
        BoxOpen(val) {
            if (val == 1) {
                this.dialog = true;
            } else {
                this.dialog = false;
                this.echartsStr.dispose();
                this.echartsStr = null;
            }
            console.log(this.dialog);
            if (this.dialog) {
                console.log("打开");
                this.getEChartValueTable()
                this.$nextTick(() => {
                    this.DrawEcharts();
                })
            }
        },


        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.slsId = row.slsId
                    console.log(jsonObj);
                    updateSysRegion(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getSysLogStatisticsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                this.tableLoading = false;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getSysLogStatisticsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                this.getEChartValueTable()
                this.tableLoading = false;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getSysLogStatisticsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.tableLoading = false;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>